import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { NewsEditComponent } from './news/news-edit/news-edit.component';
import { WorkareaComponent } from './workarea/workarea.component';

@Injectable()
export class CanDeactivateForm<T extends NewsEditComponent | WorkareaComponent> {
    canDeactivate(
        component: T,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (component.openChangesBackActionCheck) {
            return component.openChangesBackActionCheck();
        }
        return true;
    }
}
